import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Table, Spinner, Button, Form } from "react-bootstrap";
import OrderService from "../../../services/order";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import "./index.scss";

const orderService = new OrderService();

const statusColors = {
  pending: "warning",
  paid: "success",
  cancelled: "secondary",
  in_delivery: "info",
};

const OrderDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatingStatus, setUpdatingStatus] = useState(false);

  useEffect(() => {
    const fetchOrder = async () => {
      setLoading(true);
      try {
        const res = await orderService.getOrderById(id);
        setOrder(res.data);
      } catch (error) {
        showErrorToaster("Erreur lors du chargement de la commande");
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [id]);

  const handleStatusChange = async (e) => {
    const newStatus = e.target.value;
    setUpdatingStatus(true);
    try {
      const res = await orderService.changeOrderStatus(id, newStatus);
      setOrder(res.data);
    } catch (error) {
      showErrorToaster("Erreur lors du changement de statut");
    } finally {
      setUpdatingStatus(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!order) {
    return <div className="text-center mt-5">Commande introuvable</div>;
  }

  return (
    <div className="details-page container my-4">
      <Button variant="secondary" className="mb-3" onClick={() => navigate(-1)}>
        Retour
      </Button>

      <h3>Détails de la commande</h3>

      <Card className="mb-4">
        <Card.Header>Informations Client</Card.Header>
        <Card.Body>
          <p>
            <strong>Nom :</strong> {order.nom} {order.prenom}
          </p>
          <p>
            <strong>Téléphone :</strong> {order.numero}
          </p>
          <p>
            <strong>Ville :</strong> {order.ville}
          </p>
          <p>
            <strong>Code postal :</strong> {order.codePostal}
          </p>
          <p>
            <strong>Lieu :</strong> {order.lieu}
          </p>
          <p>
            <strong>Statut :</strong>{" "}
            <Form.Select
              value={order.status}
              onChange={handleStatusChange}
              disabled={updatingStatus}
              className={`d-inline w-auto ms-2 bg-${
                statusColors[order.status]
              } text-white`}>
              <option value="pending">En attente</option>
              <option value="paid">Payée</option>
              <option value="cancelled">Annulée</option>
              <option value="in_delivery">En cours de livraison</option>
            </Form.Select>
          </p>
          <p>
            <strong>Date de création :</strong>{" "}
            {new Date(order.createdAt).toLocaleString("fr-FR")}
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Header>Produits</Card.Header>
        <Card.Body>
          {order.products && order.products.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Produit</th>
                  <th>Quantité</th>
                  <th>Prix Unitaire</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {order.products.map((p, i) => (
                  <tr key={p._id}>
                    <td>{i + 1}</td>
                    <td>{p.title}</td>
                    <td>{p.quantity}</td>
                    <td>{p.price.toFixed(2)} DT</td>
                    <td>{(p.price * p.quantity).toFixed(2)} DT</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>Aucun produit dans cette commande.</p>
          )}
        </Card.Body>
      </Card>

      <Card>
        <Card.Header>Total</Card.Header>
        <Card.Body>
          <p>
            <strong>Total avant promo :</strong> {order?.totalA?.toFixed(3)} DT
          </p>
          <p>
            <strong>Total après promo :</strong> {order?.total?.toFixed(3)} DT
          </p>
          {order?.promoCode && (
            <p>
              <strong>Code promo :</strong> {order?.promoCode}
            </p>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default OrderDetailsPage;
